import { useParams } from "next/navigation";

import getCurrentStateConfig from "@/lib/helpers/get-current-state-config";

export default function useStateConfig() {
  const params = useParams();

  return getCurrentStateConfig(params["stateName"] as string);
}
